import { StoreView, StoreViewWithState } from './storeViews'

const getHrefLang = (storeView: StoreView): StoreViewWithState['hrefLang'] => {
  if (storeView.default) {
    return 'x-default'
  }
  return storeView.locale || storeView.language
}

export default getHrefLang
